"use strict";
exports.__esModule = true;
exports.chart_color_black_300 = {
  "name": "--pf-v5-chart-color-black-300",
  "value": "#b8bbbe",
  "var": "var(--pf-v5-chart-color-black-300, #b8bbbe)"
};
exports["default"] = exports.chart_color_black_300;